import type { WorkInProgressTask } from '../types/work-in-progress';

/**
 * 工作中任务报告导出服务。
 */
export interface WorkInProgressExportService {
    /**
     * 通过任务类型对应的正式业务接口导出报告，并返回下载地址。
     *
     * @param task 待导出的已完成任务。
     * @returns 报告下载地址。
     */
    exportReport(task: WorkInProgressTask): Promise<string>;
}

/**
 * 工作中任务报告导出服务的依赖注入标识。
 */
export const WorkInProgressExportService = Symbol('WorkInProgressExportService');
